import { SessionGate } from "../session/SessionGate";
import { useAuth } from "./AuthProvider";
import { LoginScreen } from "./LoginScreen";

/** Gate: anonymous -> login; authenticated -> bootstrap the session + shell. */
export function AuthedApp() {
  const { status } = useAuth();
  if (status !== "authenticated") return <LoginScreen />;
  return <SessionGate />;
}
